import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';
import router from '@/router';

// ==================== STATE =====================

function initialState() {
  return {
    total_count: null,
    list: null,
    film: null,
  };
}
const state = initialState();

// ==================== ACTIONS =====================

const actions = {
  async list(context, payload) {
    var response = await API.film.list(payload);

    context.commit('set_list', {
      films: response.films,
    });
    return response;
  },
};

// ==================== GETTERS =====================

const getters = {
  getField,
  getFilms: state => {
    return state.list;
  },
  getFilm: state => id => {
    return state.list.find(film => {
      return film.id == id;
    });
  },
  getMediasFromId: (state, getters, rootState, rootGetters) => (
    media_type,
    film_id,
  ) => {
    var media = [];
    var film = getters['getFilm'](film_id);
    film[media_type].forEach(media_id => {
      var file = rootGetters['files/getMediaFiles']('film', media_id);
      media.push(file);
    });
    return media;
  },

  getFilmFromId: state => film_id => {
    return state.list.find(film => {
      return film.id == film_id;
    });
  },
};

// ==================== MUTATIONS =====================

const mutations = {
  updateField,
  set_list(state, payload) {
    state.list = payload.films;
  },

  set_film(state, payload) {
    state.film = payload;
  },

  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
